import React from 'react';
import './BorderGradient.css';

const BorderGradient = () => (
  <hr className="border-gradient" />
);

export default React.memo(BorderGradient);



// WEBPACK FOOTER //
// ./src/components/BorderGradient/BorderGradient.jsx